<div class="overflow-control">        
    @if (filtersNode(); as filtersNode) {
        <presenter [data]="filtersNode" />
    }            
</div>